import {ToggleButton} from '@wandb/components';
import React, {useCallback} from 'react';
import {useParams} from 'react-router-dom';

import {trackPanelBankEvent} from '../../services/analytics';
import {useViewAction} from '../../state/views/hooks';
import {pinSection} from '../../state/views/panelBankConfig/actions';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';
import {useIsSectionPinned} from './useIsSectionPinned';

type PinSectionButtonProps = {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
};

export const PinSectionButton = ({
  panelBankSectionConfigRef,
}: PinSectionButtonProps) => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const pinPanelBankSection = useViewAction(panelBankConfigRef, pinSection);

  const isPinned = useIsSectionPinned(panelBankSectionConfigRef);

  const {entityName} = useParams<{entityName: string}>();

  const onClick = useCallback(() => {
    pinPanelBankSection?.(panelBankSectionConfigRef);
    /*
     * if isPinned (previous state) is true, the new state is false
     * so we track the 'pin' action, and vice versa
     */
    trackPanelBankEvent({
      action: isPinned ? 'Unpin panel bank section' : 'Pin panel bank section',
    });
  }, [isPinned, panelBankSectionConfigRef, pinPanelBankSection]);

  return (
    <ToggleButton
      variant="pin"
      isSelected={isPinned}
      tooltip={{children: 'Pin section', placement: 'bottom'}}
      aria-label="Pin section"
      onPress={onClick}
    />
  );
};
